import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import {put, takeEvery, all, fork, takeLatest} from "redux-saga/effects";
import PaymentService from '../../services/payment.service'


function* getPaymentGateways() {
  try {
    const response = yield PaymentService.listPaymentGateways();

    if (response?.data.statusCode === 200) {
      yield put(actions.getPaymentGatewaysSuccess(response.data));
    } else {
      yield put(actions.getPaymentGatewaysFailure("network error"));
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    yield put(actions.getPaymentGatewaysFailure(error));
  }
}

function* getPaymentGatewaysSaga() {
  yield takeLatest(actionsTypes.GET_PAYMENT_GATEWAYS_START, getPaymentGateways);
}

export function* paymentSaga() {
  yield all([fork(getPaymentGatewaysSaga)]);
}
